import { isEmpty } from "lodash";

export function authReducer(
	state = {
		isAuthenticated: false,
		user: {},
		userInfo: {},
		stats:{},
		isEmployee: false,
		employee: {},
		organizationName: "",
	},
	{ type, payload }
) {
	switch (type) {
		case "SET_CURRENT_USER":
			let state0 = Object.assign({}, state)

			state0.isEmployee = !isEmpty(payload) && payload.role == -1
			state0.isAuthenticated = !isEmpty(payload) && payload.role > -1
			state0.isUserPlus = !isEmpty(payload) && payload.role === 10
			state0.isAdmin = !isEmpty(payload) && payload.role > 1
			// state0.isAdmin = !isEmpty(payload) && payload.role > 1 && payload.role !== 10
			state0.isSuperAdmin = !isEmpty(payload) && payload.role > 2 && payload.role !== 10
			state0.user = payload
		
			return state0
			
		case "GET_USER_INFO":
			let state1 = Object.assign({}, state)
			state1.userInfo = payload

			return state1;
		case "GET_EMPLOYEE_INFO":
			let state2 = Object.assign({}, state)
			state2.employee = payload

			return state2;
			
		case "UPDATE_USER_ACCOUNT":
			let state3 = Object.assign({}, state)
			state3.userInfo.account = payload
			
			return state3;
		
		case "GET_ORGANIZATION_NAME":
			let state4 = Object.assign({}, state)
			state4.organizationName = payload
			
			return state4;
		// case "SET_CURRENT_EMPLOYEE":
		// 	let state3 = Object.assign({}, state)

		// 	state3.isEmployee = true
		// 	state3.isAuthenticated = false
		// 	state3.isAdmin = false
		// 	state3.isSuperAdmin = false
		// 	state3.employee = payload
		
		// 	return state3
		default:
			return state;
	}
}
